import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { NFTextAreaInput } from "src/components/Shared/NewForms/NFTextAreaInput";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";

export const AssemblyDisassemblyOfGoodsDetailAdditional = () => {
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col sm={12}>
          <NFTextAreaInput fieldName={"comment"} title={t("Comment")} required={false} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Created User")} fieldName={"createdUser"} disabled={true} />
        </Col>
        <Col sm={6}>
          <NFDateInput title={t("Created Date")} fieldName={"createdDate"} disabled={true} />
        </Col>
      </Row>
    </>
  );
};
